export default __webpack_public_path__ + "media/siteware/favicon-76-5ca15185b53184f550b609de9bfc1f86.png";